import React, { useEffect, useState } from 'react';

import Chip from '@mui/material/Chip';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

import {
  ContractRequestListResult,
  RequestStatus,
  RequestType,
  listContractRequest,
} from 'stores/ContractRequestStoreAdapter';
import { formatDate } from 'utils/DateTimeFormatter';
import { errorDefault } from 'utils/Toastify';

type ContractRequestListTabProps = {
  contractId: string;
};

const ContractRequestListTab: React.FC<ContractRequestListTabProps> = ({ contractId }) => {
  const [requests, setRequests] = useState<ContractRequestListResult[]>([]);

  useEffect(() => {
    if (contractId) {
      listContractRequest({ contractId })
        .then(setRequests)
        .catch(() => errorDefault('申請一覧の取得に失敗しました'));
    }
  }, [contractId]);

  if (requests.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
        申請はありません
      </Typography>
    );
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography variant="caption" fontWeight={600}>
                管理ID
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="caption" fontWeight={600}>
                申請種別
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="caption" fontWeight={600}>
                ステータス
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="caption" fontWeight={600}>
                申請日
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="caption" fontWeight={600}>
                承認日
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {requests.map((req) => (
            <TableRow
              key={req.contractRequestId}
              hover
              onClick={() => window.open(`/contract/request/${req.contractRequestId}`, '_blank')}
              sx={{ cursor: 'pointer' }}
            >
              <TableCell>
                <Typography variant="body2" fontWeight={600}>
                  {req.managementId}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">{RequestType[req.requestType]}</Typography>
              </TableCell>
              <TableCell>
                <Chip
                  size="small"
                  label={RequestStatus[req.requestStatus]}
                  color={
                    req.requestStatus === 'APPROVED'
                      ? 'success'
                      : req.requestStatus === 'REJECTED'
                        ? 'error'
                        : req.requestStatus === 'IN_PROGRESS'
                          ? 'warning'
                          : 'default'
                  }
                  sx={{ height: 20, fontSize: '0.7rem' }}
                />
              </TableCell>
              <TableCell>
                <Typography variant="caption" color="text.secondary">
                  {req.submittedAt ? formatDate(req.submittedAt) : '—'}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="caption" color="text.secondary">
                  {req.approvedAt ? formatDate(req.approvedAt) : '—'}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ContractRequestListTab;
